import { CSSProperties } from 'react';

export const cellContainerStyle: CSSProperties = {
  justifyContent: 'center',
  minWidth: 0,
  width: '100%',
};
